import StreamType from "types/StreamType";
import AdType from "types/AdType";

export const TRITON_PROVIDER_NAME = "TRITON";
export const MPEG_STREAM_TYPE = "application/x-mpegURL";
export const CURRENT_STREAM_NOT_FOUND = "error_current_stream_not_found";
export const CHROMECAST_TECH_NAME = "Chromecast";
export const AD_TYPES = {
    PREROLL: AdType.PREROLL,
    MIDROLL: AdType.MIDROLL
};
export const STREAM_TYPES = {
    VOD: StreamType.VOD,
    LIVE: StreamType.LIVE
};
export const AUTOPLAY_CLASS = "vjs-autoplay";
export const CONTENT_OVERLAY_CLASS = "bvp-content-overlay";
export const QUICKTAKE_CUSTOM_KEY = "quicktake";
export const BLOOMBERGTV_CUSTOM_KEY = "bloombergtv";
export const DEFAULT_ASPECT_RATIO = "16:9";

export const BLP_REGION_ERROR = "BLP Region Error";
